export enum InventoryProductType {
  PAINT = 'PAINT',
  NON_PAINT = 'NON_PAINT',
}
